// extracted by mini-css-extract-plugin
module.exports = {"button":"ExtraInfoButton_button__yFthG","container":"ExtraInfoButton_container__1bCgQ","iconVertical":"ExtraInfoButton_iconVertical__KdFIw","icon":"ExtraInfoButton_icon__isQu7"};